import z from 'zod'

// Phone number schema for Canadian/North American format
export const PhoneSchema = z
  .string()
  .regex(
    /^\d{3}-\d{3}-\d{4}$|^\(\d{3}\)\s\d{3}-\d{4}$|^\d{10}$/,
    'Phone number must be in format: 555-123-4567',
  )
